import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@core/components/ui/toast";
import { useToast } from "@core/components/ui/use-toast";

interface ToasterProps {
  /** Duration in ms before the toast auto-dismisses. Defaults to 5000 (5 seconds). */
  duration?: number;
}

export function Toaster({ duration = 5000 }: ToasterProps) {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={duration}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
